
import ChevronIcon from '~/components/ui/icons/ChevronIcon.vue';
import PortfolioPrivacyTag from '../atom/PortfolioPrivacyTag.vue';
import PortfolioRankTag from '../atom/PortfolioRankTag.vue';
import { getDateFromNow } from '~/utils/portfolio-dates';
export default {
  name: 'PortfolioInfo',
  components: {
    ChevronIcon,
    PortfolioPrivacyTag,
    PortfolioRankTag,
  },
  props: {
    showImg: {
      type: Boolean,
      default: true,
    },
    imgSrc: {
      type: String,
      default: '',
    },
    imgDisplayName: {
      type: String,
      default: '',
    },
    alt: {
      type: String,
      default: '',
    },
    showReturn: {
      type: Boolean,
      default: true,
    },
    hasDropdown: {
      type: Boolean,
      default: true,
    },
    name: {
      type: String,
      required: true,
    },
    lineCount: {
      type: Number,
      default: 0,
    },
    lastUpdated: {
      type: String,
      required: true,
    },
    dailyReturn: {
      type: Number,
      default: 0,
    },
    isRounded: {
      type: Boolean,
      default: true,
    },
    hasBorder: {
      type: Boolean,
      default: true,
    },
    dropdownOpen: {
      type: Boolean,
      default: false,
    },
    showRankIcon: {
      type: Boolean,
      default: false,
    },
    portfolioRank: {
      type: Number,
      default: 0,
    },
    isPublic: {
      type: Boolean,
      default: false,
    },
    isInPrivateLeague: {
      type: Boolean,
      default: false,
    },
    leagueId: {
      type: String,
      default: '',
    },
    leagueAvatarUri: {
      type: String,
      default: '',
    },
  },
  computed: {
    fromNow() {
      return getDateFromNow(this.lastUpdated, this.$dayjs);
    },
  },
  methods: {
    handleDropdownClick() {
      this.$emit('onDropdownClick');
    },
  },
};
